var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 5.3335C17.2799 5.3335 5.33325 17.2802 5.33325 32.0002C5.33325 46.7202 17.2799 58.6668 31.9999 58.6668C46.7199 58.6668 58.6666 46.7202 58.6666 32.0002C58.6666 17.2802 46.7199 5.3335 31.9999 5.3335ZM31.9999 53.3335C20.2399 53.3335 10.6666 43.7602 10.6666 32.0002C10.6666 20.2402 20.2399 10.6668 31.9999 10.6668C43.7599 10.6668 53.3332 20.2402 53.3332 32.0002C53.3332 43.7602 43.7599 53.3335 31.9999 53.3335ZM44.2399 20.2135L26.6666 37.7868L19.7599 30.9068L15.9999 34.6668L26.6666 45.3335L47.9999 24.0002L44.2399 20.2135Z",
    fill: "#007500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.e1e492b2e88dd66399029a9d68b3f2b7.svg";
export { ForwardRef as ReactComponent };